import { useNavigate } from '@tanstack/react-router'
import { useProblemReportState } from '../../lib/problem-reporting/host'
import { HelpMenuLauncher } from '../shared/messaging/HelpMenuLauncher'

export function AdminHelpLauncher({ canChat, unreadCount }: {
  canChat: boolean
  unreadCount: number
}) {
  const navigate = useNavigate()
  const reportHost = useProblemReportState()
  const canCreateReport = reportHost.phase === 'ready' &&
    Boolean(reportHost.policy?.enabled && reportHost.policy.can_self)

  return (
    <HelpMenuLauncher
      canChat={canChat}
      canOpenReports={Boolean(reportHost.identity)}
      canCreateReport={canCreateReport}
      unreadCount={unreadCount}
      onChat={() => { void navigate({ to: '/admin/inbox', search: { view: 'my_team' } }) }}
    />
  )
}
